// Shared huddle helpers for Town Hall + University.
//
// "Program only" is a synthetic huddle that no real user is a member of,
// which lets old mobile clients silently filter program-scoped content
// out of their public feeds. Same key, same precedence rules everywhere
// it's referenced — so the constants and the mutual-exclusion logic
// live in one place rather than being copy-pasted across stores and
// component watchers.

export const PROGRAM_ONLY_KEY = 'program_only';
export const EVERYONE_KEY = 'everyone';

// el-cascader emits values as either ['key'] (per multi-select entry)
// or 'key' (older string paths). Collapse to a single string.
export function normalizeHuddleValue(v: any): string {
  return Array.isArray(v) ? v[0] : v;
}

// Watcher helper: when "Program only" coexists with other huddle picks,
// enforce mutual exclusion. Returns the corrected array or null when no
// change is needed — the null path lets the watcher early-return without
// retriggering reactivity.
export function enforceProgramOnlyExclusivity(huddleTag: any): any[] | null {
  if (!Array.isArray(huddleTag) || huddleTag.length <= 1) return null;
  const hasProgramOnly = huddleTag.some((v) => normalizeHuddleValue(v) === PROGRAM_ONLY_KEY);
  if (!hasProgramOnly) return null;

  const last = huddleTag[huddleTag.length - 1];
  const lastIsProgramOnly = normalizeHuddleValue(last) === PROGRAM_ONLY_KEY;
  if (lastIsProgramOnly) {
    return [[PROGRAM_ONLY_KEY]];
  }
  return huddleTag.filter((v) => normalizeHuddleValue(v) !== PROGRAM_ONLY_KEY);
}
